/**
 * @flow
 * @relayHash eb862e0eed0b96e8fdd891ff4bdb46a4
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CopyUserLineItemsToCTemplateInput = {
  clientMutationId?: ?string,
  c_template_id: string,
  user_line_item_ids: $ReadOnlyArray<?string>,
};
export type Library_ContractTemplate_copyUserLineItemsToCTemplateMutationVariables = {|
  input: CopyUserLineItemsToCTemplateInput
|};
export type Library_ContractTemplate_copyUserLineItemsToCTemplateMutationResponse = {|
  +copyUserLineItemsToCTemplate: ?{|
    +c_template: ?{|
      +c_template_line_items: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +title: ?string,
            +description: ?string,
            +position: ?number,
            +price_cents: ?number,
            +price_currency: ?string,
            +quantity: ?number,
          |}
        |}>
      |}
    |}
  |}
|};
export type Library_ContractTemplate_copyUserLineItemsToCTemplateMutation = {|
  variables: Library_ContractTemplate_copyUserLineItemsToCTemplateMutationVariables,
  response: Library_ContractTemplate_copyUserLineItemsToCTemplateMutationResponse,
|};
*/


/*
mutation Library_ContractTemplate_copyUserLineItemsToCTemplateMutation(
  $input: CopyUserLineItemsToCTemplateInput!
) {
  copyUserLineItemsToCTemplate(input: $input) {
    c_template {
      c_template_line_items {
        edges {
          node {
            id
            title
            description
            position
            price_cents
            price_currency
            quantity
          }
        }
      }
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CopyUserLineItemsToCTemplateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CopyUserLineItemsToCTemplateInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "c_template_line_items",
  "storageKey": null,
  "args": null,
  "concreteType": "CTemplateLineItemConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "CTemplateLineItemEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "CTemplateLineItem",
          "plural": false,
          "selections": [
            v2,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "title",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "description",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "position",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "price_cents",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "price_currency",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "quantity",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "Library_ContractTemplate_copyUserLineItemsToCTemplateMutation",
  "id": null,
  "text": "mutation Library_ContractTemplate_copyUserLineItemsToCTemplateMutation(\n  $input: CopyUserLineItemsToCTemplateInput!\n) {\n  copyUserLineItemsToCTemplate(input: $input) {\n    c_template {\n      c_template_line_items {\n        edges {\n          node {\n            id\n            title\n            description\n            position\n            price_cents\n            price_currency\n            quantity\n          }\n        }\n      }\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "Library_ContractTemplate_copyUserLineItemsToCTemplateMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "copyUserLineItemsToCTemplate",
        "storageKey": null,
        "args": v1,
        "concreteType": "CopyUserLineItemsToCTemplatePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "c_template",
            "storageKey": null,
            "args": null,
            "concreteType": "CTemplate",
            "plural": false,
            "selections": [
              v3
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "Library_ContractTemplate_copyUserLineItemsToCTemplateMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "copyUserLineItemsToCTemplate",
        "storageKey": null,
        "args": v1,
        "concreteType": "CopyUserLineItemsToCTemplatePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "c_template",
            "storageKey": null,
            "args": null,
            "concreteType": "CTemplate",
            "plural": false,
            "selections": [
              v3,
              v2
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '43b80b1a8dc02fbe027715a8868962bd';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Document/Template/Contract/__generated__/Library_ContractTemplate_copyUserLineItemsToCTemplateMutation.graphql.js